var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"user-image",attrs:{"src":_vm.url,"alt":_vm.alt,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }